import {PhoneHQButton, PhoneHQSwitch, PhoneHQSelect, PhoneHQCombobox} from 'ch3-ui-lib';
import moment from "moment-timezone";
import {TimeField} from "../../components/DateTimeFields/DateTimeFields";
import {useEffect, useState} from "react";
import {convertAmPmToIso, convertIsoToAmPm, weekDays} from "../../utilis/timeUtilis";
import {Link, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import {useNavigate} from 'react-router-dom';
import useMediaQuery from "../../utilis/screenWidthUtils.ts";
import {
    useFetchMsisdnWorkingHoursQuery,
    useUpdateWorkingHoursMutation, WorkingHoursInterface
} from "../../store/features/MsisdnSettings/msisdnSettingsService";
import {showToast} from "../../store/features/Notifications/notificationsSlice.tsx";

const SCHEDULE_OPTIONS = [
    {value: 'EVERYDAY', label: 'Everyday'},
    {value: 'WEEKDAYS', label: 'Weekdays'},
    {value: 'CUSTOM', label: 'Custom'},
];

interface WorkingHoursProps {
    admin?: boolean;
}
const WorkingHours = ({admin}:WorkingHoursProps) => {
    const navigate = useNavigate();
    const {id} = useParams<{ id: string }>();
    const isMobile = useMediaQuery('(max-width: 960px)');

    const dispatch = useDispatch();


    const [updateData] = useUpdateWorkingHoursMutation();
    const { data: workingHoursData } = useFetchMsisdnWorkingHoursQuery(id as string);
    const [formData, setFormData] = useState({} as WorkingHoursInterface);
    const [errors, setErrors] = useState<any[]>([]);



    const timezoneList = Intl.supportedValuesOf('timeZone').map((timezone: string) => {
        return {
            key: timezone,
            value: timezone,
            label: timezone.replace(/_/g, ' ')
        }
    });
    const initialTimezone =  timezoneList.find((timezone) => timezone.key === 'America/New_York')?.value;

    useEffect(() => {
        if (workingHoursData) {
            const data = {
                ...workingHoursData,
                timeZone: timezoneList.find((timezone) => timezone.key === workingHoursData.timeZone)?.value ?? initialTimezone,
                workingHours: getWorkingHours(),
            };
            setFormData(data)
        }
    }, [id, workingHoursData]);

    const handleScheduleTypeChange = (value: string) => {
        setErrors([]);
        setFormData(getDaysHoursSettings(value));
    }

    const getWorkingHours = () => {
        if(!workingHoursData) return [];
        if(!workingHoursData.workingHours.length) return getDaysHoursSettings(workingHoursData.type).workingHours;
       return  workingHoursData.type == 'CUSTOM' ?  workingHoursData.workingHours.map((hourData) => {
            return {
                ...hourData,
                from: convertIsoToAmPm(hourData.from),
                to: convertIsoToAmPm(hourData.to),
            };
        }) : [{
            ...workingHoursData.workingHours[0],
            from: convertIsoToAmPm(workingHoursData.workingHours[0].from),
            to: convertIsoToAmPm(workingHoursData.workingHours[0].to),
        }]
    }

    const getDaysHoursSettings = (type: string):WorkingHoursInterface => {
        switch (type) {
            case 'EVERYDAY':
                return (
                    {
                        type: 'EVERYDAY',
                        timeZone: formData.timeZone,
                        enabled: true,
                        workingHours: [
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'MONDAY',
                            }
                        ]
                    }
                )
                break;
            case 'WEEKDAYS':
                return (
                    {
                        type: 'WEEKDAYS',
                        enabled: true,
                        timeZone: formData.timeZone,
                        workingHours: [
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'MONDAY',
                            }]

                    })
                break;
            case 'CUSTOM':
                return (
                    {
                        type: 'CUSTOM',
                        enabled: true,
                        timeZone: formData.timeZone,
                        workingHours: [
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'MONDAY'
                            },
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'TUESDAY'
                            },
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'WEDNESDAY'
                            },
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'THURSDAY'
                            },
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'FRIDAY'
                            },
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'SATURDAY'
                            },
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'SUNDAY'
                            }
                        ]
                    }
                )
                break;
            default:
                return (
                    {
                        type: 'EVERYDAY',
                        timeZone: formData.timeZone,
                        enabled: true,
                        workingHours: [
                            {
                                from: '09:00 AM',
                                to: '05:00 PM',
                                enabled: true,
                                day: 'MONDAY',
                            }
                        ]
                    }
                )
        }
    }

    const handeDayToggle = (index: number) => {
        const updatedHours = formData.workingHours.map((hourData, idx) => {
            if (idx === index) {
                return {
                    ...hourData,
                    enabled: !hourData.enabled,
                };
            }
            return hourData;
        });

        setFormData({...formData, workingHours: updatedHours});
    }
    const convertTo24HourFormat = (time: string): { hour: number, minute: number } => {
        const [timePart, period] = time.split(' ');
        const [hours, minutes] = timePart.split(':').map(Number);

        let hour = hours % 12;
        if (period.toLowerCase() === 'pm') {
            hour += 12;
        }

        return { hour, minute: minutes };
    };

    const validateTime = (from: string, to: string): string | null => {
        const { hour: fromHour, minute: fromMinute } = convertTo24HourFormat(from);
        const { hour: toHour, minute: toMinute } = convertTo24HourFormat(to);

        if (fromHour > toHour || (fromHour === toHour && fromMinute >= toMinute)) {
            return '"From" time should be earlier than "to" time';
        }

        return null;
    };

    const handleHoursChange = (value: string, index: number, timeType: 'from' | 'to') => {
        const updatedHours = formData.workingHours.map((hourData, idx) => {
            if (idx === index) {
                return {
                    ...hourData,
                    [timeType]: value,
                };
            }
            return hourData;
        });

        const currentData = updatedHours[index];
        const error = validateTime(currentData.from, currentData.to);

        const updatedErrors = [...errors];
        if (error) {
            updatedErrors[index] = error;
        } else {
            updatedErrors.splice(index, 1);
        }

        setFormData({...formData, workingHours: updatedHours});
        setErrors(updatedErrors);
    };


    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
                const data = {
            ...formData,
            workingHours: formData.workingHours.map((hourData) => {
                return {
                    ...hourData,
                    from: convertAmPmToIso(hourData.from, formData.timeZone),
                    to: convertAmPmToIso(hourData.to, formData.timeZone),
                };
            })
        }


        const hasFieldErrors = errors.length > 0;

        if (hasFieldErrors) {
            return;
        }

        if (id) {
            try {
                await updateData({id, data});
                dispatch(showToast({description: 'Your settings have been updated.', type: 'success'}));
                navigate((admin ? '/admin' : '') + '/phoneNumbers');
            } catch (e) {
                dispatch(showToast({description:'Unexpected error. Please try again', type: 'error'}));
                console.error(e);
            }
        }


    };

    return (
        <>
            {Object.keys(formData).length && (
                <div className='w-full '>

        <div className={`${isMobile ? ' px-4' : ''}`}>
            <div className=' overflow-x-hidden  overflow-y-auto '>
                        <div className={`flex flex-col gap-3`} >
                            <div>
                                <div className='text-body-strong text-ink'>
                                    Set working hours
                                </div>
                                <div className='mt-1 text-footnote text-ink-muted'>
                                    Control how your phone numbers work at different times of day
                                </div>
                            </div>
                            <div className='grid w-full gap-4 rounded-card border border-solid border-line bg-surface p-4'>
                                <PhoneHQCombobox
                                    label="Timezone"
                                    placeholder="Search timezone"
                                    value={formData?.timeZone}
                                    onSelect={(item) => setFormData({...formData, timeZone: item.value})}
                                    items={timezoneList}/>
                                <div className={`flex flex-col    `}>
                                    <div>
                                        <div className='flex justify-between items-center border-0 border-t border-solid border-surface-muted pt-4'>
                                            <div className='text-callout font-semibold text-ink'>
                                                Schedule
                                            </div>
                                            <PhoneHQSwitch checked={formData.enabled} onCheckedChange={() => setFormData({...formData, enabled: !formData.enabled})} switchFirst/>

                                        </div>
                                        <div className='pb-4 text-footnote text-ink-muted items-center'>
                                        Set the schedule. Calls during these hours will be routed to the users assigned to this phone number
                                        </div>
                                    </div>
                                    {Boolean(formData.enabled) && <>
                                        <div
                                            className={`justify-between items-start pb-6 gap-6 grid ${formData?.type !== 'Custom' && '!flex'} + ${isMobile ? ' flex' : ' '}`}>
                                            <PhoneHQSelect
                                                aria-label="Schedule"
                                                className="w-[270px]"
                                                value={formData?.type}
                                                onChange={(value) => handleScheduleTypeChange(value)}
                                                options={SCHEDULE_OPTIONS}
                                            />

                                        </div>
                                        <div>
                                            {Boolean(formData?.type !== 'CUSTOM') &&
                                                formData?.workingHours.map((_, index) => {
                                                        return (
                                                            <>
                                                                <div>
                                                                    <div className={'flex gap-24 mb-8'}>

                                                                        <div className='flex gap-8 items-center font-medium'>
                                                                            from <div><AmPmTimeField invalid={Boolean(errors[index])} value={formData.workingHours[index].from} onChange={(value: string) => handleHoursChange(value, index, 'from')}/>
                                                                        </div>
                                                                            to <div>
                                                                            <AmPmTimeField invalid={Boolean(errors[index])} value={formData.workingHours[index].to} onChange={(value: string) => handleHoursChange(value, index, 'to')}/>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    {errors[index] && <div
                                                                        className='text-danger-ink text-center ml-14'>{errors[index]}</div>}

                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                )
                                            }
                                            {Boolean(formData?.type == 'CUSTOM') &&
                                                formData?.workingHours.map((hour, index: any) => {

                                                    return (
                                                        <>
                                                            <div className={'flex justify-between items-center  py-2 mr-0'}>

                                                                <div className='w-[180px]'>
                                                                    {Boolean(formData?.type == 'CUSTOM') &&
                                                                        <PhoneHQSwitch checked={hour.enabled}
                                                                                onCheckedChange={() => handeDayToggle(index)}
                                                                                label={hour?.day.toLocaleLowerCase()}
                                                                                switchFirst/>
                                                                    }
                                                                </div>
                                                                <div>
                                                                    <div className='flex  items-center justify-end'>
                                                                        from <div className="mx-2">
                                                                        <AmPmTimeField className="w-[180px]" invalid={Boolean(errors[index])} value={formData.workingHours[index].from} onChange={(value: string) => handleHoursChange(value, index, 'from')}/>
                                                                    </div>
                                                                        to <div className="ml-2"><AmPmTimeField className="w-[180px]" invalid={Boolean(errors[index])} value={formData.workingHours[index].to} onChange={(value: string) => handleHoursChange(value, index, 'to')}/>
                                                                    </div>
                                                                    </div>
                                                                    {errors[index] &&
                                                                        <div
                                                                            className='text-danger-ink text-center ml-14'>{errors[index]}</div>}
                                                                </div>


                                                            </div>

                                                        </>
                                                    )
                                                })

                                            }
                                        </div>
                                        <div>
                                            {Boolean(formData?.type !== 'CUSTOM') &&
                                                formData?.workingHours.map((hour, index) => {
                                                    return (
                                                        <div className='mx-4 mb-8' key={index}>
                                                            {weekDays.map((day) => {
                                                                const isWeekend = day === 'Saturday' || day === 'Sunday';
                                                                return (
                                                                    <div className='flex gap-8 items-center mb-5' key={day}>
                                                                        <div className='w-[90px] items-center'>
                                                                            {day}
                                                                        </div>
                                                                        <div className='font-semibold'>
                                                                            {isWeekend && formData?.type == 'WEEKDAYS' ? (
                                                                                <div className='font-normal'> Not working on
                                                                                    this day</div>
                                                                            ) : (
                                                                                hour.enabled ? (
                                                                                    `${formData.workingHours[index].from} - ${formData.workingHours[index].to}`
                                                                                ) : (
                                                                                    'Not working on this day'
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })}

                                        </div>
                                    </>}
                                </div>
                            </div>

                        </div>

                        <div className={`mx-8 mt-8 flex justify-end `}>
                            <div className='flex gap-3 justify-end  items-start'>
                                <Link to={'/phoneNumbers'}><PhoneHQButton variant="secondary" size="lg" phq-id='phoneNumberWorkingHours-cancelBtn' >Cancel</PhoneHQButton></Link>
                                <PhoneHQButton size="lg" onClick={(e) => handleSubmit(e)} phq-id='phoneNumberWorkingHours-saveChangesBtn' >Done</PhoneHQButton>
                            </div>
                        </div>
                    </div>

                </div>
                </div>
            )}
        </>
    );
};
export default WorkingHours;

/** Working hours keep "09:00 AM" strings; the field shows and picks 24-hour time in 5-minute steps. */
const AmPmTimeField = ({value, onChange, invalid, className}: { value: string; onChange: (value: string) => void; invalid?: boolean; className?: string }) => {
    const m = moment(value, 'hh:mm A');
    return (
        <TimeField
            hour={m.isValid() ? m.hours() : 9}
            minute={m.isValid() ? m.minutes() : 0}
            step={5}
            invalid={invalid}
            className={className}
            onChange={(h, min) => onChange(moment().hours(h).minutes(min).format('hh:mm A'))}
        />
    );
};
